import type { NavigateFunction, NavigateOptions, To } from 'react-router';

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigateFn: NavigateFunction) => {
  globalNavigate = navigateFn;
};

export const navigate = (to: To, options?: NavigateOptions) => {
  if (!globalNavigate) {
    console.error('navigate function is not initialized');
    return;
  }
  globalNavigate(to, options);
};
